import api from "../_api";

const store = async (commit, body) => {
  const result = await api.store(body);
  return result;
};

const index = async ({ commit }, params) => {
  const result = await api.index(params);
  commit("STORE_USERS", result);
};

const show = async ({ commit }, id) => {
  const result = await api.show(id);
  commit("STORE_USER", result);
};

const update = async (commit, param) => {
  const result = await api.update(param.body, param.id);
  return result;
};

const setStatus = async (commit, param) => {
  const result = await api.setStatus(param.body, param.id);
  return result;
};

const deleteUser = async (commit, id) => {
  const result = await api.deleteUser(id);
  return result;
};

const meRegister = async (commit, body) => {
  const result = await api.meRegister(body);
  return result;
};

export default {
  store,
  index,
  show,
  update,
  setStatus,
  deleteUser,
  meRegister
};
